import { Icon3d3d, Icon3dAlert, Icon3dCycle, Icon3dDetect, Icon3dLocation, Icon3dMeter } from '@assets/images/icon';
import { accessAutoThumb, deadboltThumb, emlockThumb } from '@assets/images/main/access/product';
import { IconAoaOff, IconAoaOn, IconComfortOff, IconComfortOn, IconOsOff, IconOsOn, IconTwintrackerOff, IconTwintrackerOn } from '@assets/images/main/icon';
import { IconBlueShield } from '@assets/images/main/icon/blue';
import {
  rtlsScreenshot1D,
  rtlsScreenshot1T,
  rtlsScreenshot1M,
  rtlsScreenshot2D,
  rtlsScreenshot2T,
  rtlsScreenshot2M,
  rtlsScreenshot3D,
  rtlsScreenshot3T,
  rtlsScreenshot3M,
  rtlsScreenshot4D,
  rtlsScreenshot4T,
  rtlsScreenshot4M,
  accessKey1,
  accessKey2,
  accessKey3,
  accessKey4,
  accessOutlook,
  IconBox,
  IconComputer,
  IconGuarantee,
  assetOn,
  workerOn,
  workerOff,
  IconPath,
  IconLocation,
  IconAnalyze,
  IconAlarm,
  IconExcel,
  IconSDK,
  assetOff,
} from '@assets/images/main/index';
import {
  RtlsFunctions1D,
  RtlsFunctions1M,
  RtlsFunctions1T,
  RtlsFunctions2D,
  RtlsFunctions2M,
  RtlsFunctions2T,
  RtlsFunctions3D,
  RtlsFunctions3M,
  RtlsFunctions3T,
  RtlsFunctions4D,
  RtlsFunctions4M,
  RtlsFunctions4T,
  RtlsFunctions5D,
  RtlsFunctions5M,
  RtlsFunctions5T,
} from '@assets/images/main/rtls/main/functions';
import {
  RtlsHardware1D,
  RtlsHardware1M,
  RtlsHardware1T,
  RtlsHardware2D,
  RtlsHardware2M,
  RtlsHardware2T,
  RtlsHardware3D,
  RtlsHardware3M,
  RtlsHardware3T,
  RtlsHardware4D,
  RtlsHardware4M,
  RtlsHardware4T,
} from '@assets/images/main/rtls/main/hardware';
import { assetTag, twinTracker1, twinTrackerBracket } from '@assets/images/main/rtls/product';
import {
  screenViewRtls1,
  screenViewRtls2,
  screenViewRtls3,
  screenViewRtls4,
  screenViewRtls5,
  screenViewRtls6,
  screenViewRtls7,
  screenViewRtls8,
} from '@assets/images/main/screenView';
import { ReactComponent as SvgScope } from '@assets/images/icon/svg/scope.svg';
import { ReactComponent as SvgBuildingLine } from '@assets/images/icon/svg/building-line.svg';
import { ReactComponent as SvgTopology } from '@assets/images/icon/svg/topology.svg';
import { ReactComponent as SvgZoneLine } from '@assets/images/icon/svg/zone-line.svg';
import { ReactComponent as SvgSunLine } from '@assets/images/icon/svg/sun-line.svg';
import { ReactComponent as SvgRoute } from '@assets/images/icon/svg/route.svg';
import { ReactComponent as SvgTagsLine } from '@assets/images/icon/svg/tags-line.svg';
import { ReactComponent as Svg3DLine } from '@assets/images/icon/svg/3d-line.svg';

export default {
  banner: {
    title: 'Indoor location tracking<br/>simpler. more accurate.',
    desc: 'From fixed to portable,<br/>experience high-precision location tracking technology that can be applied without spatial constraints.',
    schemeTitle: 'Choose the right location tracking for you.',
    schemeDesc: 'Do you need help deciding? ',
    schemeDesc2: '<br/>contact us we will have an access expert assist you.',
    phone: '(+82)1522-9928',

    card: [
      {
        title: 'The Only One in Korea',
        desc: 'Applied for location tracking<br/>Manufacturing network devices',
      },
      {
        title: 'Over 5 Billion Records',
        desc: `Asia's largest-scale<br/>real-time location data`,
      },
      {
        title: 'World-Class Performance',
        desc: 'Highest level of location accuracy<br/>using AI algorithms',
      },
    ],
  },

  mainPage: {
    product: {
      title: 'Learn about the product configuration',
      desc: 'Check out the innovative location tracking product configuration.',
      asset: {
        title: 'Bluetooth (BLE) Location Tracking',
        desc: 'Attach a BLE tag device to the subject you want to monitor or track as an asset, enabling real-time location tracking.',
      },
      worker: {
        title: 'UWB Precision Tracking',
        desc: 'Attach a UWB tag device to the subject you want to monitor or track as an asset, enabling real-time location tracking.',
      },
    },
  },
  screenView: {
    title: 'Accurate Location Tracking to Connect Assets and Spaces',
    data: [
      { icon: SvgScope, text: 'Real-Time Location Tracking', img: screenViewRtls1 },
      { icon: SvgBuildingLine, text: 'Large-Scale Asset Management', img: screenViewRtls2 },
      { icon: SvgTopology, text: 'Network Status Monitoring', img: screenViewRtls3 },
      { icon: SvgZoneLine, text: 'Zone Management', img: screenViewRtls4 },
      { icon: SvgSunLine, text: 'Heatmap Spatial Analysis', img: screenViewRtls5 },
      { icon: SvgRoute, text: 'Movement Path Analysis', img: screenViewRtls6 },
      { icon: SvgTagsLine, text: 'Tag Device Management', img: screenViewRtls7 },
      { icon: Svg3DLine, text: '3D Viewer Support', img: screenViewRtls8 },
    ],
  },
  screenShot: [
    {
      title: 'Visualize the Entire Site on a Map',
      desc: 'Location data based on BLE/UWB/AoA is displayed in real time on building layouts and zone maps.<br/>With floor views, zone filters, and status icons, visual management becomes easy.',
      img: {
        desktop: rtlsScreenshot1D,
        tablet: rtlsScreenshot1T,
        mobile: rtlsScreenshot1M,
      },
    },
    {
      title: 'Rewind Past Movements as if They Were Live',
      desc: 'You can record and replay the movement history of people or assets based on a timeline.<br/>Select a specific time to compare routes of individuals or groups, or review any anomalies.',
      img: {
        desktop: rtlsScreenshot2D,
        tablet: rtlsScreenshot2T,
        mobile: rtlsScreenshot2M,
      },
    },
    {
      title: 'See the Most Active Areas at a Glance',
      desc: 'Provides a heatmap feature that visualizes movements by time slot.<br/>Use it to analyze congested areas, inefficient routes, or underutilized spaces for layout optimization and staffing plans.',
      img: {
        desktop: rtlsScreenshot3D,
        tablet: rtlsScreenshot3T,
        mobile: rtlsScreenshot3M,
      },
    },
    {
      title: 'Instant Reaction When Entering a Defined Zone',
      desc: 'With ORBRO OS, you can define any zone directly on the map.<br/>When a person or asset enters or exits the zone, an alert is triggered instantly.<br/>These alerts are also available via API for flexible integration with external systems.',
      img: {
        desktop: rtlsScreenshot4D,
        tablet: rtlsScreenshot4T,
        mobile: rtlsScreenshot4M,
      },
    },
  ],
  video: {
    title: 'ORBRO positioning system',
    desc: [
      {
        text: 'The dashboard function allows you to quickly check the status of the device,<br/>the classification status of the tag terminal by category, and the status of each area at a glance.',
      },
      { text: 'You can quickly determine the location and status of the target based on the device.<br/>Provides accurate data and an easy interface.' },
      { text: 'Quickly set up workspaces to hazardous areas<br/>and get a quick view of the status of each area.' },
      { text: 'Quickly send alarms for various situations,<br/>including when entering a hazardous area.' },
    ],
  },

  functions: {
    title: 'Innovative Experience with Location Tracking System',
    desc: `ORBRO's location tracking system offers users the best experience by providing both web-based administration and a mobile app. Through this, you can experience the highest level of user convenience among existing location tracking systems.`,

    line: 2,
    card: [
      {
        size: '3',
        tag: 'Integrated Management Software',
        title: 'Software Based on Indoor Maps',
        label: 'Administrator',
        img: {
          desktop: RtlsFunctions1D,
          tablet: RtlsFunctions1T,
          mobile: RtlsFunctions1M,
        },
      },
      {
        size: '1',
        tag: 'Mobile App Provided',
        title: 'Location Tracking via Mobile App',
        label: 'Common Offer',
        img: {
          desktop: RtlsFunctions2D,
          tablet: RtlsFunctions2T,
          mobile: RtlsFunctions2M,
        },
      },
      {
        size: '2',
        tag: 'Device History Management',
        title: 'Real-Time Recording of Device Locations by Zone',
        label: 'Administrator',
        img: {
          desktop: RtlsFunctions3D,
          tablet: RtlsFunctions3T,
          mobile: RtlsFunctions3M,
        },
      },
      {
        size: '2',
        tag: 'Zone Configuration',
        title: 'Real-Time Device Tracking by Zone',
        label: 'Administrator',
        img: {
          desktop: RtlsFunctions4D,
          tablet: RtlsFunctions4T,
          mobile: RtlsFunctions4M,
        },
      },
      {
        size: '2',
        tag: 'Device Management',
        title: 'Convenient Device Management',
        label: 'Administrator',
        img: {
          desktop: RtlsFunctions5D,
          tablet: RtlsFunctions5T,
          mobile: RtlsFunctions5M,
        },
      },
    ],
  },

  hardware: {
    title: 'The Core is Hardware, Everything Innovates Lightly',
    desc: `Our location tracking system's devices are specially crafted with directional antennas and designed considering on-site environments. Applying directional antennas for optimal performance and stability, it operates effectively in various situations.`,
    card: [
      {
        img: {
          desktop: RtlsHardware1D,
          tablet: RtlsHardware1T,
          mobile: RtlsHardware1M,
        },
        tag: 'Directional Antenna',
        title: 'Accurate Location Tracking with Directional Antenna',
        desc: 'The TwinTracker (Location Tracking Device) directional antenna can infer the direction of wireless signals.',
      },
      {
        img: {
          desktop: RtlsHardware2D,
          tablet: RtlsHardware2T,
          mobile: RtlsHardware2M,
        },
        tag: 'Various Brackets',
        title: 'Ceiling Flush Mount, Ray Installation Possible',
        falldown: [
          {
            title: 'Ceiling Flush Mount Bracket',
            desc: 'Various ceiling installations possible,<br/>including plaster, tex, SMC, Myton, etc.',
          },
          {
            title: 'Rail-type Bracket',
            desc: 'Same specifications as the rail used for lighting,<br/>making it easy to install anytime if the ceiling has the rail in place.',
          },
        ],
      },
      {
        img: {
          desktop: RtlsHardware3D,
          tablet: RtlsHardware3T,
          mobile: RtlsHardware3M,
        },
        tag: 'Innovative Technology',
        title: 'Minimum Installation, Maximum Performance Using TDoA Technology',
        desc: 'TDoA technology is a communication technology that maintains high-performance communication while innovatively reducing battery consumption. It operates in real-time, yet records much higher location precision compared to traditional methods.',
      },
      {
        img: {
          desktop: RtlsHardware4D,
          tablet: RtlsHardware4T,
          mobile: RtlsHardware4M,
        },
        tag: 'Various Communication Methods',
        title: 'Wired Communication, Wireless Communication, Both Connectable',
      },
    ],
  },

  faqRequest: 'Feel free to ask',
  faqRequestTail: 'anything.',
  FAQ: [
    {
      title: 'I have no technical knowledge. Can I still use the system?',
      description:
        'ORBRO provides a simple yet powerful interface that anyone can use, even without technical expertise.<br/>We designed the system to allow intuitive usage through visualized data.',
    },
    {
      title: 'How accurate is the positioning?',
      description: 'ORBRO RTLS system offers highly precise positioning.<br/>It is optimized for real-time data delivery with almost no error or delay.',
    },
    {
      title: 'Is it only for location tracking? Can I add other features?',
      description:
        'ORBRO’s technology is highly expandable.<br/>You can also apply features like route analysis, unauthorized area detection, and movement alerts.',
    },
    {
      title: 'How does ORBRO’s tracking system work?',
      description:
        'ORBRO uses wireless technologies like BLE, UWB, and AoA to calculate position data based on signals transmitted by tags and received by anchors.<br/>The calculated data is shown in real time on ORBRO OS map screens and mobile apps.',
    },
    {
      title: 'What’s the difference between TwinTracker BLE, UWB, and AoA?',
      description:
        'BLE: Low power, easy setup, approx. 1–3m accuracy<br/>UWB: High precision (10–30cm), fast response, great in complex environments<br/>AoA: Angle-based BLE positioning, ideal for indoor route analysis',
    },
    {
      title: 'Can Comfort Kit be used with ORBRO?',
      description:
        'Comfort Kit is a standalone mobile-based device that works without ORBRO OS or server.<br/>It provides real-time location info via smartphone app, even in serverless environments.',
    },
    {
      title: 'What environment does ORBRO OS run in?',
      description:
        'ORBRO OS is used in environments with ORBRO Server or Edge installed.<br/>It offers tracking, event monitoring, and history analysis.<br/>The map-based UI is intuitive for both administrators and operators.',
    },
    {
      title: 'Can I use the location data in external systems?',
      description: 'Yes, ORBRO provides an API for integration.<br/>You can use the data in smart factory platforms, security systems, and more.',
    },
    {
      title: 'Can I use multiple devices at once on one site?',
      description: 'Yes.<br/>You can mix BLE, UWB, and AoA devices in one platform,<br/>and build a hybrid solution for complex environments.',
    },
    {
      title: 'Can it track both indoor and outdoor locations?',
      description: 'Yes. BLE, UWB, and AoA are used indoors,<br/>while GPS is used outdoors to create a hybrid setup.',
    },
    {
      title: 'How many tags can the system handle at once?',
      description:
        'Depending on system design and server capacity, from dozens to thousands.<br/>ORBRO supports stable tracking even in large-scale deployments.',
    },
    {
      title: 'Is installation and maintenance difficult?',
      description:
        'ORBRO supports the full process from planning to installation and testing.<br/>Most devices support remote monitoring and firmware updates.<br/>Maintenance is simple with occasional battery changes and inspections.',
    },
    {
      title: 'How can I view the location data?',
      description:
        'You can view location data on the ORBRO OS map interface,<br/>or through the mobile app in real time.<br/>Data can also be accessed via API for use in external systems.',
    },
  ],

  bannerData: [
    {
      icon: IconTwintrackerOn,
      iconInv: IconTwintrackerOff,
      image: '',
      iconText: 'TwinTracker UWB',
      sub: 'New',
      link: '/en/rtls/uwb',
    },
    {
      icon: IconAoaOn,
      iconInv: IconAoaOff,
      image: '',
      iconText: 'TwinTracker AoA',
      sub: 'New',
      link: '/en/rtls/aoa',
    },
    {
      icon: IconTwintrackerOn,
      iconInv: IconTwintrackerOff,
      image: '',
      iconText: 'TwinTracker BLE',
      sub: 'New',
      link: '/en/rtls/ble',
    },
    {
      icon: IconComfortOn,
      iconInv: IconComfortOff,
      image: '',
      iconText: 'Comfort Kit',
      sub: 'New',
      link: '/en/rtls/comfort',
    },
  ],

  product: {
    asset: {
      func: 'The product, which has a built-in battery, can easily and quickly control the entrance door via mobile without the need for power construction by attaching it next to the entrance door.',
      key1: accessKey1,
      key2: accessKey2,
      key3: accessKey3,
      key4: accessKey4,
      outlook: accessOutlook,
    },
  },

  purchaseDesc: {
    asset: 'Attach a BLE tag device to the subject you want to monitor or track as an asset, enabling real-time location tracking.',
    worker: 'Attach a UWB tag device to the subject you want to monitor or track as an asset, enabling real-time location tracking.',
  },

  purchase: {
    //Mobile
    asset: {
      assetTracking: {
        icon: accessKey1,
        title: 'Asset Location Tracking',
        serial: 'Asset-Tracking',
        price: '5,900,000',

        note: [
          { text: 'TwinTracker (BLE) 10 units', icon: IconBox },
          { text: 'Asset tracking tag 30 units', icon: IconBox },
          { text: 'Server PC 1 unit', icon: IconComputer },
          { text: '3-year warranty', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'Asset Tag(BLE)',
            price: '30,000',
            img: assetTag,
          },
          {
            title: 'TwinTracker(BLE)',
            price: '300,000',
            img: twinTracker1,
          },
          {
            title: 'TwinTracker Bracket',
            price: '100,000',
            img: twinTrackerBracket,
          },
        ],
        mark: '',
      },
    },

    //Automatic door entry
    worker: {
      workerTracking: {
        icon: accessKey1,
        title: 'Worker Location Tracking',
        serial: 'Worker-Tracking',
        price: '5,000,000',

        note: [
          { text: 'TwinTracker (UWB) 10 units', icon: IconBox },
          { text: 'Worker tracking tag 10 units', icon: IconBox },
          { text: 'Server PC 1 unit', icon: IconComputer },
          { text: '3-year warranty', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'Tag(UWB)',
            price: '60,000',
            img: emlockThumb,
          },
          {
            title: 'TwinTracker(UWB)',
            price: '300,000',
            img: deadboltThumb,
          },
          {
            title: 'TwinTracker Bracket',
            price: '100,000',
            img: accessAutoThumb,
          },
        ],
        mark: '',
      },
    },
  },
  func: {
    title: 'Explore More Features',
    desc: 'Discover various functions of location tracking.',

    data: [
      {
        img: IconBlueShield,
        title: 'Permission & Group Management',
        desc: 'Manage feature access by assigning roles to administrators and users. You can also create groups by department or team.',
      },
      {
        img: IconAlarm,
        title: 'Alert Levels (5 Stages)',
        desc: 'Configure 5 alert levels based on custom conditions to detect and respond to anomalies quickly.',
      },
      {
        img: Icon3dMeter,
        title: 'Zone Monitoring',
        desc: 'Define zones on the map and monitor the presence of people or assets in real time within those zones.',
      },
      {
        img: Icon3dCycle,
        title: 'Reverse Movement Detection',
        desc: 'Automatically detect movement in the opposite direction of predefined routes and issue warnings.',
      },
      {
        img: Icon3dLocation,
        title: 'Category-Based Tracking',
        desc: 'Classify tag devices by type such as personnel, assets, or vehicles for efficient data management and analysis.',
      },
      {
        img: Icon3dAlert,
        title: 'Undetected Tag Alerts',
        desc: 'Send automatic alerts to administrators when a tag is not detected for a certain period of time.',
      },
      {
        img: Icon3dDetect,
        title: 'In/Out Zone Detection',
        desc: 'Automatically detect entries and exits in access zones, and support analysis of stay duration and access logs.',
      },
      {
        img: Icon3d3d,
        title: 'Device Search & Status Monitoring',
        desc: 'Easily search for multiple tags and anchors, and monitor battery and connection status at a glance.',
      },
    ],
  },
};
